// extracted by mini-css-extract-plugin
export default {"frameWrapper":"iTM0Hf4U","_shorts":"Hz594vUJ","frame":"nY1ZWiXP"};